import React, { useState, useEffect, useRef } from 'react';

/* ── SVG Icons ── */
const CodeIcon = () => (
  <svg viewBox="0 0 48 48" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polyline points="16,14 6,24 16,34" stroke="#ff4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="32,14 42,24 32,34" stroke="#ff4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="28" y1="10" x2="20" y2="38" stroke="#ff6666" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const CircuitIcon = () => (
  <svg viewBox="0 0 48 48" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="18" y="18" width="12" height="12" rx="2" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <line x1="18" y1="10" x2="18" y2="18" stroke="#ff4444" strokeWidth="2"/>
    <line x1="30" y1="10" x2="30" y2="18" stroke="#ff4444" strokeWidth="2"/>
    <line x1="18" y1="30" x2="18" y2="38" stroke="#ff4444" strokeWidth="2"/>
    <line x1="30" y1="30" x2="30" y2="38" stroke="#ff4444" strokeWidth="2"/>
    <line x1="10" y1="22" x2="18" y2="22" stroke="#ff4444" strokeWidth="2"/>
    <line x1="30" y1="22" x2="38" y2="22" stroke="#ff4444" strokeWidth="2"/>
    <circle cx="18" cy="10" r="2.5" fill="#ff4444"/>
    <circle cx="30" cy="10" r="2.5" fill="#ff4444"/>
    <circle cx="18" cy="38" r="2.5" fill="#ff4444"/>
    <circle cx="30" cy="38" r="2.5" fill="#ff4444"/>
    <circle cx="10" cy="22" r="2.5" fill="#ff4444"/>
    <circle cx="38" cy="22" r="2.5" fill="#ff4444"/>
  </svg>
);

const GearSvgIcon = () => (
  <svg viewBox="0 0 48 48" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg" className="spin-gear">
    <circle cx="24" cy="24" r="7" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <path d="M24 6 L26 12 L22 12 Z" fill="#ff4444"/>
    <path d="M24 42 L26 36 L22 36 Z" fill="#ff4444"/>
    <path d="M6 24 L12 26 L12 22 Z" fill="#ff4444"/>
    <path d="M42 24 L36 26 L36 22 Z" fill="#ff4444"/>
    <path d="M10.1 10.1 L14.2 14.8 L11.5 17.5 Z" fill="#ff4444"/>
    <path d="M37.9 37.9 L33.8 33.2 L36.5 30.5 Z" fill="#ff4444"/>
    <path d="M10.1 37.9 L14.8 33.8 L17.5 36.5 Z" fill="#ff4444"/>
    <path d="M37.9 10.1 L33.2 14.2 L30.5 11.5 Z" fill="#ff4444"/>
    <circle cx="24" cy="24" r="3" fill="#ff4444" opacity="0.5"/>
  </svg>
);

const TargetIcon = () => (
  <svg viewBox="0 0 48 48" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="18" stroke="#ff4444" strokeWidth="2" opacity="0.4"/>
    <circle cx="24" cy="24" r="12" stroke="#ff4444" strokeWidth="2" opacity="0.65"/>
    <circle cx="24" cy="24" r="6" stroke="#ff4444" strokeWidth="2" opacity="0.85"/>
    <circle cx="24" cy="24" r="2.5" fill="#ff2222"/>
    <line x1="24" y1="6" x2="24" y2="2" stroke="#ff4444" strokeWidth="2"/>
    <line x1="24" y1="42" x2="24" y2="46" stroke="#ff4444" strokeWidth="2"/>
    <line x1="6" y1="24" x2="2" y2="24" stroke="#ff4444" strokeWidth="2"/>
    <line x1="42" y1="24" x2="46" y2="24" stroke="#ff4444" strokeWidth="2"/>
  </svg>
);

const TrophySvgIcon = () => (
  <svg viewBox="0 0 48 48" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 6h20v18a10 10 0 01-20 0V6z" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <path d="M6 8h8v8a4 4 0 01-8 0V8z" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <path d="M34 8h8v8a4 4 0 01-8 0V8z" stroke="#ff4444" strokeWidth="1.5" fill="rgba(255,68,68,0.05)"/>
    <line x1="24" y1="34" x2="24" y2="40" stroke="#ff4444" strokeWidth="2"/>
    <rect x="16" y="40" width="16" height="3" rx="1.5" stroke="#ff4444" strokeWidth="2" fill="rgba(255,68,68,0.1)"/>
    <path d="M19 18 l5 4 l5-8" stroke="#ff2244" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EmailSvgIcon = () => (
  <svg viewBox="0 0 20 20" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="4" width="16" height="12" rx="2" stroke="#ff4444" strokeWidth="1.5"/>
    <polyline points="2,4 10,11 18,4" stroke="#ff4444" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

const PhoneSvgIcon = () => (
  <svg viewBox="0 0 20 20" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 2h4l2 4-2.5 1.5a11 11 0 005 5L14 10l4 2v4a2 2 0 01-2 2A16 16 0 012 4a2 2 0 012-2z" stroke="#ff4444" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

const RocketIcon = () => (
  <svg viewBox="0 0 20 20" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 2 C10 2 14 5 14 11 L10 15 L6 11 C6 5 10 2 10 2z" stroke="white" strokeWidth="1.5" fill="rgba(255,255,255,0.15)"/>
    <circle cx="10" cy="8" r="2" stroke="white" strokeWidth="1.5"/>
    <path d="M6 11 L3 16 L7 14.5" stroke="white" strokeWidth="1.2"/>
    <path d="M14 11 L17 16 L13 14.5" stroke="white" strokeWidth="1.2"/>
  </svg>
);

/* ── Particle Canvas ── */
const ParticleCanvas = () => {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    resize();
    window.addEventListener('resize', resize);

    const particles = Array.from({ length: 55 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: (Math.random() - 0.5) * 0.4,
      vy: (Math.random() - 0.5) * 0.4,
      r: Math.random() * 1.5 + 0.5,
      alpha: Math.random() * 0.5 + 0.1,
    }));

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = canvas.width;
        if (p.x > canvas.width) p.x = 0;
        if (p.y < 0) p.y = canvas.height;
        if (p.y > canvas.height) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,68,68,${p.alpha})`;
        ctx.fill();
      });
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.strokeStyle = `rgba(255,68,68,${0.07 * (1 - dist / 120)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      animId = requestAnimationFrame(draw);
    };
    draw();
    return () => { cancelAnimationFrame(animId); window.removeEventListener('resize', resize); };
  }, []);
  return <canvas ref={canvasRef} style={{ position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none' }} />;
};

/* ── useInView hook ── */
const useInView = (threshold = 0.15) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
};

/* ── Org Chart Component ── */
const OrgChart = () => {
  const nodes = {
    manager: { role: 'Team Manager', name: 'Assoc. Prof. Ir. Ts. Dr. Mohd Ridzuan Bin Ahmad', email: 'ridzuan@fke.utm.my', phone: '+6013-761 2778' },
    leader: { role: 'Team Leader', name: 'Ennis Lam Si Hoong', email: 'theleaderrbc@gmail.com', phone: '+6018-665 9511' },
    vice: { role: 'Vice Team Leader', name: 'Chen Shu Yan', email: 'utmrbcvp@gmail.com', phone: '+6017-201 1393' },
    treasurer: { role: 'Treasurer', name: 'Moh Nian Chun', email: 'utmrbctreasurer@gmail.com', phone: '+6011-3155 6877' },
    hr: { role: 'Human Resource', name: 'Ong Wei Lun', email: 'utmrbchr@gmail.com', phone: '+6011-1659 0426' },
    secretary: { role: 'Secretary', name: 'Wong Jia Xuan', email: 'utmroboconsecretary@gmail.com', phone: '+6011-11978253' },
  };

  const [hovered, setHovered] = useState(null);

  const NodeCard = ({ id, node, className = '' }) => (
    <div
      className={`org-node ${className} ${hovered === id ? 'org-node-hovered' : ''}`}
      onMouseEnter={() => setHovered(id)}
      onMouseLeave={() => setHovered(null)}
    >
      <div className="org-node-glow-top" />
      <div className="org-role">{node.role}</div>
      <div className="org-name">{node.name}</div>
      <div className="org-contacts">
        <a href={`mailto:${node.email}`} className="org-contact-row">
          <span className="org-ci"><EmailSvgIcon /></span>
          <span>{node.email}</span>
        </a>
        <a href={`tel:${node.phone}`} className="org-contact-row">
          <span className="org-ci"><PhoneSvgIcon /></span>
          <span>{node.phone}</span>
        </a>
      </div>
      <div className="org-node-edge" />
    </div>
  );

  return (
    <div className="org-chart">
      {/* Tier 1 — Manager */}
      <div className="org-tier">
        <NodeCard id="manager" node={nodes.manager} className="org-node--top" />
      </div>

      {/* Connector: Manager → Leader */}
      <div className="org-connector-v">
        <div className="org-line-v" />
      </div>

      {/* Tier 2 — Leader */}
      <div className="org-tier">
        <NodeCard id="leader" node={nodes.leader} className="org-node--mid" />
      </div>

      {/* Connector: Leader → Vice */}
      <div className="org-connector-v">
        <div className="org-line-v" />
      </div>

      {/* Tier 3 — Vice */}
      <div className="org-tier">
        <NodeCard id="vice" node={nodes.vice} className="org-node--mid" />
      </div>

      {/* Connector: Vice → branch */}
      <div className="org-branch-connector">
        <div className="org-branch-stem" />
        <div className="org-branch-bar" />
        <div className="org-branch-drops">
          <div className="org-branch-drop" />
          <div className="org-branch-drop org-branch-drop--mid" />
          <div className="org-branch-drop" />
        </div>
      </div>

      {/* Tier 4 — Treasurer | HR | Secretary */}
      <div className="org-tier org-tier--bottom">
        <NodeCard id="treasurer" node={nodes.treasurer} className="org-node--leaf" />
        <NodeCard id="hr" node={nodes.hr} className="org-node--leaf" />
        <NodeCard id="secretary" node={nodes.secretary} className="org-node--leaf" />
      </div>
    </div>
  );
};

/* ── Main Component ── */
const AboutUs = () => {
  const [heroVisible, setHeroVisible] = useState(false);
  const [storyRef, storyInView] = useInView();
  const [vmRef, vmInView] = useInView();
  const [mgmtRef, mgmtInView] = useInView();
  const [deptRef, deptInView] = useInView();
  const [ctaRef, ctaInView] = useInView();

  useEffect(() => { setTimeout(() => setHeroVisible(true), 120); }, []);

  const departments = [
    { icon: <CodeIcon />, title: 'Programming Dept.', description: 'Specializing in software development, control systems, and artificial intelligence for our robots. Implement cutting-edge solutions on real hardware.', skills: ['Software Dev', 'Control Systems', 'AI / ML', 'Algorithm Design'] },
    { icon: <CircuitIcon />, title: 'Electronic Dept.', description: 'Focusing on circuit design, sensor integration, and electrical systems implementation. Develop expertise in electronics and embedded control.', skills: ['Circuit Design', 'Sensor Integration', 'PCB Dev', 'Power Systems'] },
    { icon: <GearSvgIcon />, title: 'Mechanism Dept.', description: 'Handling mechanical design, fabrication, and assembly of robotic systems. Learn CAD, manufacturing, and engineering principles in a real build environment.', skills: ['CAD Design', 'Fabrication', 'Assembly', 'Material Science'] },
  ];

  return (
    <div className="au ext-page">
      <ParticleCanvas />

      {/* Circuit grid overlay */}
      <svg className="grid-overlay" viewBox="0 0 1400 900" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
        {[0,100,200,300,400,500,600,700,800,900,1000,1100,1200,1300,1400].map(x =>
          <line key={`v${x}`} x1={x} y1="0" x2={x} y2="900" stroke="#ff4444" strokeWidth="0.4" opacity="0.04"/>
        )}
        {[0,100,200,300,400,500,600,700,800,900].map(y =>
          <line key={`h${y}`} x1="0" y1={y} x2="1400" y2={y} stroke="#ff4444" strokeWidth="0.4" opacity="0.04"/>
        )}
        <line x1="200" y1="0" x2="200" y2="200" stroke="#ff4444" strokeWidth="0.8" opacity="0.1"/>
        <line x1="200" y1="200" x2="500" y2="200" stroke="#ff4444" strokeWidth="0.8" opacity="0.1"/>
        <circle cx="200" cy="200" r="3" fill="#ff4444" opacity="0.15"/>
        <line x1="1200" y1="900" x2="1200" y2="650" stroke="#ff4444" strokeWidth="0.8" opacity="0.1"/>
        <line x1="1200" y1="650" x2="900" y2="650" stroke="#ff4444" strokeWidth="0.8" opacity="0.1"/>
        <circle cx="1200" cy="650" r="3" fill="#ff4444" opacity="0.15"/>
      </svg>

      <div className="scanlines" />

      <div className="wrapper">

        {/* ── HERO ── */}
        <section className={`hero ${heroVisible ? 'visible' : ''}`}>
          <div className="hero-tag">
            <span className="tag-dot" />
            <span className="tag-text">UNIVERSITI TEKNOLOGI MALAYSIA // ROBOCON_UNIT</span>
          </div>
          <h1 className="hero-title">
            ABOUT<br />
            <span className="hero-accent">UTM <span className="hero-red">ROBOCON</span></span>
          </h1>
          <div className="hero-bar">
            <div className="hbar-l" /><span className="hbar-label">EST. 2002</span><div className="hbar-r" />
          </div>
          <p className="hero-desc">
            Pioneering robotics excellence since 2002 — showcasing the talent and dedication of UTM students competing on the world stage.
          </p>
        </section>

        {/* ── STORY ── */}
        <section className={`sec ${storyInView ? 'sec-in' : ''}`} ref={storyRef}>
          <div className="sec-shell">
            <div className="glass-card story-card">
              <div className="card-glow-top" />
              <SectionHeader tag="// ORIGIN" title="OUR STORY" />
              <p className="story-text">
                Universiti Teknologi Malaysia proudly launched UTM Robocon in <em>2002</em>, aiming to showcase the incredible talent and dedication of its students in the field of robotics and technology. Over two decades, we have grown into a formidable team that continues to push the boundaries of innovation and excellence.
              </p>
              <div className="card-edge-line" />
            </div>
          </div>
        </section>

        {/* ── VISION & MISSION ── */}
        <section className={`sec ${vmInView ? 'sec-in' : ''}`} ref={vmRef}>
          <div className="sec-shell">
            <SectionHeader tag="// DIRECTIVES" title="VISION & MISSION" centered />
            <div className="vm-grid">
              <div className="glass-card vm-card">
                <div className="card-glow-top" />
                <div className="vm-icon-wrap pulse-ring">
                  <TargetIcon />
                </div>
                <h3 className="vm-title">OUR MISSION</h3>
                <p className="vm-text">To promote excellence of Universiti Teknologi Malaysia in robotics and technology, especially the spirit, dedication and thoroughness of students in constructing robots.</p>
                <div className="card-edge-line" />
              </div>
              <div className="glass-card vm-card">
                <div className="card-glow-top" />
                <div className="vm-icon-wrap pulse-ring">
                  <TrophySvgIcon />
                </div>
                <h3 className="vm-title">OUR VISION</h3>
                <p className="vm-text">To become the best team in every ABU ROBOCON competition and inspire the next generation of robotics engineers.</p>
                <div className="card-edge-line" />
              </div>
            </div>
          </div>
        </section>

        {/* ── MANAGEMENT (ORG CHART) ── */}
        <section className={`sec ${mgmtInView ? 'sec-in' : ''}`} ref={mgmtRef}>
          <div className="sec-shell">
            <SectionHeader tag="// COMMAND_STRUCTURE" title="MANAGEMENT BOARD" centered />
            <OrgChart />
          </div>
        </section>

        {/* ── DEPARTMENTS ── */}
        <section className={`sec ${deptInView ? 'sec-in' : ''}`} ref={deptRef}>
          <div className="sec-shell">
            <SectionHeader tag="// DEPARTMENTS" title="OUR DIVISIONS" centered subtitle="Join a specialized division and master cutting-edge technologies" />
            <div className="dept-grid">
              {departments.map((d, i) => (
                <div className="glass-card dept-card" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
                  <div className="card-glow-top" />
                  <div className="dept-icon-wrap">{d.icon}</div>
                  <h3 className="dept-title">{d.title}</h3>
                  <p className="dept-desc">{d.description}</p>
                  <div className="skills-row">
                    {d.skills.map((s, j) => (
                      <span className="skill-chip" key={j} style={{ animationDelay: `${j * 0.08}s` }}>{s}</span>
                    ))}
                  </div>
                  <button className="join-btn">
                    <span className="join-btn-bg" />
                    <span className="join-btn-inner"><RocketIcon /> JOIN DIVISION</span>
                  </button>
                  <div className="card-edge-line" />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── CTA ── */}
        <section className={`sec cta-sec ${ctaInView ? 'sec-in' : ''}`} ref={ctaRef}>
          <div className="sec-shell">
            <div className="glass-card cta-card">
              <div className="cta-sweep" />
              <div className="card-glow-top" />
              <div className="cta-alert">
                <span className="alert-dot" /><span>// RECRUITMENT_OPEN</span>
              </div>
              <h2 className="cta-title">READY TO BUILD THE FUTURE?</h2>
              <p className="cta-sub">Join UTM Robocon and be part of Malaysia's premier robotics team. Together, we'll create innovative solutions and compete on the global stage.</p>
              <div className="cta-btns">
                <button className="btn-primary">
                  <span className="btn-shine" />
                  <span className="btn-inner"><RocketIcon /> APPLY NOW</span>
                </button>
                <button className="btn-secondary">LEARN MORE</button>
              </div>
              <div className="card-edge-line" />
            </div>
          </div>
        </section>

      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600;700;900&family=Rajdhani:wght@300;400;500;600;700&family=Share+Tech+Mono&display=swap');

        *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}

        .au {
          position: relative;
          min-height: 100vh;
          background: #080810;
          font-family: 'Rajdhani', sans-serif;
          color: #e0e0e0;
          overflow-x: hidden;
        }

        /* ── Overlays ── */
        .grid-overlay {
          position: fixed; inset: 0; width: 100%; height: 100%;
          z-index: 1; pointer-events: none;
        }
        .scanlines {
          position: fixed; inset: 0; z-index: 2; pointer-events: none;
          background: repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,0,0,0.06) 2px, rgba(0,0,0,0.06) 4px);
        }

        /* ── Layout ── */
        .wrapper { position: relative; z-index: 3; max-width: var(--external-content-max-width); margin: 0 auto; padding: 0 var(--external-content-x) var(--external-page-bottom); }
        .sec-shell { width: 100%; max-width: 1080px; margin: 0 auto; }

        /* ── Section reveal ── */
        .sec {
          margin-bottom: var(--external-section-gap);
          opacity: 0; transform: translateY(30px);
          transition: opacity 0.75s ease, transform 0.75s ease;
        }
        .sec.sec-in { opacity: 1; transform: none; }

        /* ── HERO ── */
        .hero {
          padding: 7rem 0 5rem;
          text-align: center;
          opacity: 0; transform: translateY(28px);
          transition: opacity 0.85s ease, transform 0.85s ease;
        }
        .hero.visible { opacity: 1; transform: none; }

        .hero-tag {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(255,68,68,0.07);
          border: 1px solid rgba(255,68,68,0.22);
          border-radius: 2px; padding: 5px 14px; margin-bottom: 2rem;
        }
        .tag-dot {
          width: 7px; height: 7px; border-radius: 50%; background: #ff4444;
          box-shadow: 0 0 8px #ff4444;
          animation: blink 1.6s ease-in-out infinite;
        }
        @keyframes blink { 0%,100%{opacity:1}50%{opacity:0.3} }
        .tag-text {
          font-family: 'Share Tech Mono', monospace; font-size: 0.65rem;
          color: #ff7766; letter-spacing: 1.5px;
        }

        .hero-title {
          font-family: 'Orbitron', sans-serif;
          font-size: clamp(2.8rem, 6.5vw, 5.5rem);
          font-weight: 900; line-height: 0.9; color: #fff;
          margin-bottom: 1.6rem;
        }
        .hero-accent { display: block; }
        .hero-red {
          color: #ff2222;
          text-shadow: 0 0 18px rgba(255,34,34,0.7), 0 0 40px rgba(255,34,34,0.35);
          animation: glow-pulse 3s ease-in-out infinite;
        }
        @keyframes glow-pulse {
          0%,100%{text-shadow:0 0 18px rgba(255,34,34,0.7),0 0 40px rgba(255,34,34,0.35)}
          50%{text-shadow:0 0 28px rgba(255,34,34,0.9),0 0 60px rgba(255,34,34,0.5)}
        }

        .hero-bar {
          display: flex; align-items: center; gap: 1rem; margin: 0 auto 1.6rem; max-width: 480px;
        }
        .hbar-l,.hbar-r { flex:1; height:1px; }
        .hbar-l { background: linear-gradient(90deg, transparent, #ff4444); }
        .hbar-r { background: linear-gradient(90deg, #ff4444, transparent); }
        .hbar-label {
          font-family: 'Share Tech Mono', monospace; font-size: 0.62rem;
          color: #ff6644; letter-spacing: 3px; white-space: nowrap;
        }

        .hero-desc { font-size: 1.1rem; color: #8a97a8; line-height: 1.75; max-width: 560px; margin: 0 auto; }

        /* ── Section Header ── */
        .sh-wrap { margin-bottom: 2.8rem; text-align: center; }
        .sh-tag {
          font-family: 'Share Tech Mono', monospace; font-size: 0.62rem;
          color: #555; letter-spacing: 1.5px; display: block; margin-bottom: 0.4rem;
        }
        .sh-title {
          font-family: 'Orbitron', sans-serif; font-size: clamp(1.4rem, 3vw, 2rem);
          font-weight: 900; color: #fff; letter-spacing: 4px; margin-bottom: 0.8rem;
          display: inline-block; position: relative;
        }
        .sh-title::after {
          content: ''; position: absolute; left: 0; bottom: -6px;
          width: 0; height: 2px;
          background: linear-gradient(90deg, #ff4444, #ff6666);
          transition: width 1.2s ease;
        }
        .sec-in .sh-title::after { width: 100%; }
        .sh-divider {
          height: 1px; max-width: 60px; margin-top: 1rem;
          background: linear-gradient(90deg, #ff4444, transparent);
        }
        .sh-divider { margin: 1rem auto 0; }
        .sh-sub {
          font-size: 0.95rem; color: #7a8a9a; margin-top: 0.8rem;
          max-width: 540px; line-height: 1.6;
        }
        .sh-sub { margin: 0.8rem auto 0; }

        /* ── Glass Card ── */
        .glass-card {
          background: rgba(10,10,16,0.82);
          border: 1px solid rgba(255,68,68,0.12);
          border-radius: 6px;
          position: relative; overflow: hidden;
          backdrop-filter: blur(18px);
          transition: border-color 0.3s, box-shadow 0.3s, transform 0.3s;
        }
        .glass-card:hover {
          border-color: rgba(255,68,68,0.38);
          box-shadow: 0 0 28px rgba(255,68,68,0.1), inset 0 0 20px rgba(255,68,68,0.04);
          transform: translateY(-4px);
        }
        .card-glow-top {
          position: absolute; top: 0; left: 0; right: 0; height: 1px;
          background: linear-gradient(90deg, transparent, rgba(255,68,68,0.65), transparent);
        }
        .card-edge-line {
          position: absolute; bottom: 0; left: 0; right: 0; height: 1px;
          background: linear-gradient(90deg, transparent, rgba(255,68,68,0.18), transparent);
        }

        /* ── Story ── */
        .story-card { padding: 3rem; width: 100%; }
        .story-text { font-size: 1.05rem; color: #8a97a8; line-height: 1.85; }
        .story-text em { color: #ff8888; font-style: normal; font-weight: 600; }

        /* ── VM ── */
        .vm-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(320px,1fr)); gap: 1.8rem; }
        .vm-card { padding: 2.5rem; text-align: center; }
        .vm-icon-wrap {
          width: 72px; height: 72px; border-radius: 50%;
          background: rgba(255,68,68,0.07); border: 1px solid rgba(255,68,68,0.2);
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 1.5rem; position: relative;
        }
        .pulse-ring::before {
          content: ''; position: absolute; inset: -6px; border-radius: 50%;
          border: 1px solid rgba(255,68,68,0.25);
          animation: ring-pulse 2.5s ease-in-out infinite;
        }
        @keyframes ring-pulse {
          0%,100%{opacity:0.5;transform:scale(1)}
          50%{opacity:1;transform:scale(1.08)}
        }
        .vm-title {
          font-family: 'Orbitron', sans-serif; font-size: 0.85rem;
          font-weight: 700; color: #ff4444; letter-spacing: 3px; margin-bottom: 1rem;
        }
        .vm-text { font-size: 0.95rem; color: #8a97a8; line-height: 1.7; }

        /* ── Spinning gear ── */
        .spin-gear { animation: spin 8s linear infinite; }
        @keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }

        /* ════════════════════════════════
           ── ORG CHART ──
        ════════════════════════════════ */
        .org-chart {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
        }

        /* Each horizontal tier */
        .org-tier {
          display: flex;
          justify-content: center;
          gap: 1.4rem;
          width: 100%;
        }

        /* ── Org Node base ── */
        .org-node {
          background: rgba(10,10,16,0.82);
          border: 1px solid rgba(255,68,68,0.12);
          border-radius: 6px;
          position: relative;
          overflow: hidden;
          backdrop-filter: blur(18px);
          padding: 1.4rem 1.6rem;
          transition: border-color 0.3s, box-shadow 0.3s, transform 0.3s;
          cursor: default;
        }
        .org-node:hover,
        .org-node-hovered {
          border-color: rgba(255,68,68,0.42);
          box-shadow: 0 0 24px rgba(255,68,68,0.12), inset 0 0 16px rgba(255,68,68,0.05);
          transform: translateY(-3px);
        }
        .org-node-glow-top {
          position: absolute; top: 0; left: 0; right: 0; height: 1px;
          background: linear-gradient(90deg, transparent, rgba(255,68,68,0.65), transparent);
        }
        .org-node-edge {
          position: absolute; bottom: 0; left: 0; right: 0; height: 1px;
          background: linear-gradient(90deg, transparent, rgba(255,68,68,0.18), transparent);
        }

        /* ── Tier-specific sizing ── */
        .org-node--top {
          width: 100%;
          max-width: 520px;
          border-color: rgba(255,68,68,0.28);
          box-shadow: 0 0 20px rgba(255,34,34,0.08);
        }
        .org-node--top .org-role {
          background: rgba(255,34,34,0.14);
          border-color: rgba(255,68,68,0.38);
          color: #ff4444;
        }

        .org-node--mid {
          width: 100%;
          max-width: 440px;
          border-color: rgba(255,68,68,0.18);
        }
        .org-node--mid .org-role {
          color: #ff7755;
          background: rgba(255,68,68,0.08);
          border-color: rgba(255,68,68,0.25);
        }

        .org-node--leaf {
          flex: 1;
          min-width: 200px;
        }
        .org-node--leaf .org-role {
          color: #ff9966;
          background: rgba(255,68,68,0.06);
          border-color: rgba(255,68,68,0.2);
        }

        /* ── Inside node ── */
        .org-role {
          font-family: 'Share Tech Mono', monospace;
          font-size: 0.58rem;
          letter-spacing: 2px;
          text-transform: uppercase;
          border: 1px solid;
          border-radius: 2px;
          display: inline-block;
          padding: 2px 9px;
          margin-bottom: 0.65rem;
        }
        .org-name {
          font-family: 'Rajdhani', sans-serif;
          font-size: 0.95rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 0.85rem;
          line-height: 1.3;
        }
        .org-contacts {
          display: flex;
          flex-direction: column;
          gap: 0.4rem;
        }
        .org-contact-row {
          display: flex; align-items: center; gap: 7px;
          font-size: 0.78rem; color: #7a8a9a; text-decoration: none;
          transition: color 0.2s, text-shadow 0.2s;
        }
        .org-contact-row:hover {
          color: #ff6644;
          text-shadow: 0 0 8px rgba(255,100,68,0.4);
        }
        .org-ci { display: flex; align-items: center; flex-shrink: 0; }

        /* ── Vertical connector (single line) ── */
        .org-connector-v {
          display: flex;
          justify-content: center;
          height: 32px;
          width: 100%;
          position: relative;
        }
        .org-line-v {
          width: 1px;
          height: 100%;
          background: linear-gradient(180deg, rgba(255,68,68,0.5), rgba(255,68,68,0.2));
        }

        /* ── Branch connector (Vice → 3 leaves) ── */
        .org-branch-connector {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          height: 44px;
        }

        /* Stem going down from Vice */
        .org-branch-stem {
          width: 1px;
          height: 18px;
          background: linear-gradient(180deg, rgba(255,68,68,0.5), rgba(255,68,68,0.3));
          flex-shrink: 0;
        }

        /* Horizontal bar spanning all 3 branches */
        .org-branch-bar {
          position: absolute;
          top: 18px;
          left: calc(50% - 33.33%);
          right: calc(50% - 33.33%);
          height: 1px;
          background: linear-gradient(90deg,
            rgba(255,68,68,0.1),
            rgba(255,68,68,0.45) 20%,
            rgba(255,68,68,0.45) 80%,
            rgba(255,68,68,0.1)
          );
        }

        /* Three drops going down to each leaf */
        .org-branch-drops {
          position: absolute;
          top: 18px;
          left: 0; right: 0;
          display: flex;
          justify-content: space-between;
          padding: 0 calc(50% / 3);
        }
        .org-branch-drop {
          width: 1px;
          height: 26px;
          background: linear-gradient(180deg, rgba(255,68,68,0.35), rgba(255,68,68,0.15));
        }
        .org-branch-drop--mid {
          /* Center drop aligns with center leaf */
        }

        /* ── Bottom tier spacing ── */
        .org-tier--bottom {
          align-items: stretch;
        }

        /* ── Responsive ── */
        @media(max-width: 900px) {
          .org-branch-bar {
            left: calc(50% - 40%);
            right: calc(50% - 40%);
          }
          .org-branch-drops {
            padding: 0 calc(50% / 3.5);
          }
        }

        @media(max-width: 768px) {
          .wrapper { padding: 0 var(--external-content-x-mobile) var(--external-page-bottom-mobile); }
          .hero { padding: 5rem 0 3rem; }
          .vm-grid { grid-template-columns: 1fr; }
          .dept-grid { grid-template-columns: 1fr; }
          .cta-btns { flex-direction: column; }
          .btn-primary, .btn-secondary { width: 100%; justify-content: center; }
          .story-card, .cta-card { padding: 2rem; }
          .sec { margin-bottom: var(--external-section-gap-mobile); }

          /* Stack org chart on mobile */
          .org-tier--bottom {
            flex-direction: column;
            align-items: center;
            gap: 0.8rem;
          }
          .org-node--leaf {
            width: 100%;
            max-width: 440px;
          }
          .org-branch-bar { display: none; }
          .org-branch-drops { display: none; }
          .org-branch-stem { height: 10px; }
          .org-branch-connector { height: 10px; }
          /* Separator between leaf nodes on mobile */
          .org-tier--bottom .org-node--leaf + .org-node--leaf::before {
            content: '';
            display: block;
            width: 1px;
            height: 14px;
            background: rgba(255,68,68,0.3);
            margin: 0 auto -14px;
            position: relative;
            top: -14px;
          }
        }

        /* ── Departments ── */
        .dept-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px,1fr)); gap: 1.8rem; }
        .dept-card { padding: 2.2rem; text-align: center; }
        .dept-icon-wrap {
          width: 68px; height: 68px; border-radius: 50%;
          background: rgba(255,68,68,0.06); border: 1px solid rgba(255,68,68,0.18);
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 1.4rem;
          transition: background 0.3s, box-shadow 0.3s;
        }
        .dept-card:hover .dept-icon-wrap {
          background: rgba(255,68,68,0.14);
          box-shadow: 0 0 20px rgba(255,68,68,0.25);
        }
        .dept-title {
          font-family: 'Orbitron', sans-serif; font-size: 0.82rem;
          font-weight: 700; color: #fff; letter-spacing: 2.5px; margin-bottom: 0.9rem;
          text-transform: uppercase;
        }
        .dept-desc { font-size: 0.9rem; color: #7a8a9a; line-height: 1.7; margin-bottom: 1.4rem; }

        .skills-row { display: flex; flex-wrap: wrap; gap: 0.5rem; justify-content: center; margin-bottom: 1.8rem; }
        .skill-chip {
          font-family: 'Share Tech Mono', monospace; font-size: 0.6rem;
          color: #ff6644; background: rgba(255,68,68,0.08);
          border: 1px solid rgba(255,68,68,0.2); border-radius: 2px;
          padding: 3px 10px; letter-spacing: 0.5px;
          opacity: 0; animation: chip-in 0.4s ease forwards;
        }
        .sec-in .skill-chip { opacity: 0; animation: chip-in 0.4s ease forwards; }
        @keyframes chip-in { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:none} }

        .join-btn {
          position: relative; background: none; border: none; cursor: pointer;
          border-radius: 3px; overflow: hidden; padding: 0;
          font-family: 'Orbitron', sans-serif;
          animation: btn-pulse 2.5s ease-in-out infinite;
        }
        @keyframes btn-pulse {
          0%,100%{box-shadow:0 0 12px rgba(255,34,34,0.3)}
          50%{box-shadow:0 0 24px rgba(255,34,34,0.55)}
        }
        .join-btn-bg {
          position: absolute; inset: 0;
          background: linear-gradient(135deg, #cc1111, #ff4444, #cc1111);
          background-size: 200% 100%;
          animation: grad-shift 3s linear infinite;
        }
        @keyframes grad-shift { 0%{background-position:0%}100%{background-position:200%} }
        .join-btn-inner {
          position: relative; z-index: 1; display: flex; align-items: center;
          gap: 6px; padding: 0.8rem 1.8rem;
          font-size: 0.7rem; font-weight: 700; color: #fff; letter-spacing: 2px;
        }
        .join-btn:hover { transform: translateY(-2px) scale(1.03); }

        /* ── CTA ── */
        .cta-card { padding: 3.5rem; width: 100%; text-align: center; }
        .cta-sweep {
          position: absolute; inset: 0;
          background: radial-gradient(ellipse at 30% 50%, rgba(255,34,34,0.07), transparent 70%);
          animation: sweep 5s ease-in-out infinite alternate;
        }
        @keyframes sweep {
          from{background-position:0% 50%}
          to{background-position:100% 50%}
        }
        .cta-alert {
          display: inline-flex; align-items: center; gap: 8px;
          font-family: 'Share Tech Mono', monospace; font-size: 0.62rem;
          color: #ff6644; letter-spacing: 2px; margin-bottom: 1.4rem;
        }
        .alert-dot {
          width: 7px; height: 7px; border-radius: 50%; background: #ff4444;
          box-shadow: 0 0 8px #ff4444; animation: blink 1s infinite;
        }
        .cta-title {
          font-family: 'Orbitron', sans-serif; font-size: clamp(1.4rem, 3vw, 2rem);
          font-weight: 900; color: #fff; letter-spacing: 3px; margin-bottom: 1rem;
        }
        .cta-sub { font-size: 1rem; color: #7a8a9a; line-height: 1.7; margin: 0 auto 2.2rem; max-width: 580px; }
        .cta-btns { display: flex; gap: 1.2rem; flex-wrap: wrap; justify-content: center; }

        .btn-primary {
          position: relative; background: #dd1111; border: none;
          border-radius: 3px; cursor: pointer; overflow: hidden; padding: 0;
          font-family: 'Orbitron', sans-serif; transition: transform 0.25s, box-shadow 0.25s;
          box-shadow: 0 0 16px rgba(255,17,17,0.35);
        }
        .btn-primary:hover {
          transform: translateY(-3px) scale(1.03);
          box-shadow: 0 0 32px rgba(255,34,34,0.55);
        }
        .btn-shine {
          position: absolute; top: 0; left: -80%;
          width: 50%; height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.18), transparent);
          transition: left 0.55s ease;
        }
        .btn-primary:hover .btn-shine { left: 130%; }
        .btn-inner {
          position: relative; z-index: 1; display: flex; align-items: center;
          gap: 8px; padding: 0.9rem 2.2rem;
          font-size: 0.72rem; font-weight: 700; color: #fff; letter-spacing: 2px;
        }

        .btn-secondary {
          background: transparent; color: #ff4444;
          border: 1px solid rgba(255,68,68,0.4); border-radius: 3px;
          padding: 0.9rem 2.2rem; cursor: pointer;
          font-family: 'Orbitron', sans-serif; font-size: 0.7rem;
          font-weight: 600; letter-spacing: 2px;
          transition: all 0.25s;
        }
        .btn-secondary:hover {
          background: rgba(255,68,68,0.1); border-color: #ff4444;
          box-shadow: 0 0 18px rgba(255,68,68,0.2);
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
};

/* ── Section Header Component ── */
const SectionHeader = ({ tag, title, subtitle }) => (
  <div className="sh-wrap">
    <span className="sh-tag">{tag}</span>
    <h2 className="sh-title">{title}</h2>
    <div className="sh-divider" />
    {subtitle && <p className="sh-sub">{subtitle}</p>}
  </div>
);

export default AboutUs;